import {
    REQUEST_BILLINGS_POSTED,
    REQUEST_BILLINGS_POSTED_FAILURE,
    REQUEST_BILLINGS_POSTED_SUCCESS
} from "../../../constant/transaction/BillingConstant";


const initialState = {
    billingsPosted: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const billingsPostedReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_BILLINGS_POSTED:
            return {
                ...state,
                billingsPosted: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_BILLINGS_POSTED_SUCCESS:
            return {
                ...state,
                billingsPosted: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_BILLINGS_POSTED_FAILURE:
            return {
                ...state,
                billingsPosted: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
